module.exports = __webpack_public_path__ + "img/interac-etransfer.2b584b35.svg";